import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from '../../../utils/util';
import { onValueChange } from '../../../utils/handleChangeHooks';
import { ListPagination, Title, Subtitle, BackButton, Input } from '../../../components/UI/ComponentsUI';
import PartNumberQuantityListItem from './PartNumberQuantityListItem';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import * as actionPhysicalConfirmation from '../../../actions/physicalConfirmationAction';

const PartNumberQuantityList = (props) => {
    const [partNumberQuantityList, setPartNumberQuantityList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [filter, setFilter] = useState({ partNumberCode: "" });

    useEffect(() => {
        if (props.partNumberQuantityList?.items?.length > 0) {
            if (partNumberQuantityList.length > 0 && currentPage === 0) {
                setPartNumberQuantityList(props.partNumberQuantityList.items);
            } else {
                setPartNumberQuantityList((prevState) => ([...prevState, ...props.partNumberQuantityList.items]));
            }
        } else {
            setPartNumberQuantityList([]);
        }
        // eslint-disable-next-line
    }, [props?.partNumberQuantityList?.items]);

    useEffect(() => {
        filter.pageIndex = currentPage;
        props.get(filter);
        // eslint-disable-next-line
    }, [currentPage, refresh]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onFilter = () => {
        setCurrentPage(0);
        setRefresh(refresh + 1);
    }

    const onSelectItemChange = (partNumberQuantity) => {
        props.setPartNumberQuantity(partNumberQuantity);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('cimpallet', 'partnumber-quantity')} />
                    <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('list-cimpallet', 'partnumber-quantity')} />
                </div>
            </div>
            <div className="container" style={{ marginTop: '25px', }}>
                <div className="row">
                    <div className="input-field padding col s12">
                        <i className='mdi mdi-filter-outline posfix' style={{ top: '0rem' }} onClick={onFilter} />
                        <Input
                            id="partNumberCode"
                            name='partNumberCode'
                            placeholder={translate('fields.partNumberCode', 'partnumber-quantity')}
                            type="text"
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '0px', }}>
                <div id="qrCodesList" className="container-fluid">
                    <ListPagination
                        page={props.partNumberQuantityList?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={partNumberQuantityList.map((item, index) => {
                            return (
                                <PartNumberQuantityListItem
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={`oi-${index}`}
                                    route={{ pathname: '../partNumberQuantity/insert', state: { update: true } }}
                                    data={item}
                                    onSelectChange={() => onSelectItemChange(item)}
                                    refreshComponent={() => setRefresh(refresh + 1)}
                                />
                            );
                        })}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        partNumberQuantityList: state.physicalConfirmationReducer.partNumberQuantityList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        get: (filter) => {
            dispatch(PhysicalConfirmationService.getPartNumberQuantity(filter));
        },
        setPartNumberQuantity: (item) => {
            dispatch(actionPhysicalConfirmation.setPartNumberQuantity(item));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartNumberQuantityList));
